import { render, staticRenderFns } from "./finish_details.vue?vue&type=template&id=c527ba2a&scoped=true&"
import script from "./finish_details.vue?vue&type=script&lang=js&"
export * from "./finish_details.vue?vue&type=script&lang=js&"
import style0 from "./finish_details.vue?vue&type=style&index=0&id=c527ba2a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c527ba2a",
  null
  
)

export default component.exports